import { z } from 'zod'

/**
 * What a company-defined lead stat counts. Mirrors the `LeadStatsMetricKind` enum
 * in the Prisma schema (`check:enums`). See docs/gohighlevel-stats.spec.md,
 * "Numbers".
 *
 * - `leads`: couples in a pipeline matching stages, results, tags and sources.
 * - `appointments`: appointments on chosen calendars with chosen statuses.
 * - `conversion`: the total of some numbers divided by the total of others.
 */
export const LEAD_STATS_METRIC_KINDS = [
  'leads',
  'appointments',
  'conversion',
] as const

export const leadStatsMetricKindSchema = z.enum(LEAD_STATS_METRIC_KINDS)

export type LeadStatsMetricKind = z.infer<typeof leadStatsMetricKindSchema>

/**
 * A counted number on the dashboard. A conversion is a ratio of these, so it is
 * a column of its own and not a number of this kind.
 */
export const LEAD_STATS_NUMBER_KINDS = ['leads', 'appointments'] as const satisfies readonly LeadStatsMetricKind[]

export const leadStatsNumberKindSchema = z.enum(LEAD_STATS_NUMBER_KINDS)

export type LeadStatsNumberKind = z.infer<typeof leadStatsNumberKindSchema>
